/* eslint-disable @typescript-eslint/naming-convention */
import { DataAnalyticsTaggingEvent, DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';
import { TransferDocumentType, TransferType } from './transfers.domain';

export class TransfersAnalytics {

  static transfersModalTaggingEvents: DataAnalyticsTaggingEvents = {
    modalTransfersCash: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'cash',
        subSection1: 'transfers',
        subSection2: 'cash',
        customPageName: 'wb_modal-transfers-cash'
      },
      process: {
        processName: 'tdw:wbt:cash:transfer'
      }
    },
    modalTransfersCash_Review: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'cash-review',
        subSection1: 'transfers',
        subSection2: 'cash-review',
        customPageName: 'wb_modal-transfers-cash-review'
      },
      process: {
        processName: 'tdw:wbt:cash:transfer',
        processType: 'tdw:wbt:non-recurring:transfer:start'
      }
    },
    modalTransfersCash_Confirmation: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'cash-confirmation',
        subSection1: 'transfers',
        subSection2: 'cash-confirmation',
        customPageName: 'wb_modal-transfers-cash-confirmation'
      },
      process: {
        processName: 'tdw:wbt:cash:transfer',
        processType: 'tdw:wbt:non-recurring:transfer:complete'
      }
    },
    modalTransfersOfi: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'ofi',
        subSection1: 'transfers',
        subSection2: 'ofi',
        customPageName: 'wb_modal-transfers-ofi'
      },
      process: {
        processName: 'tdw:wbt:ofi:transfer'
      }
    },
    modalTransfersOfi_Review: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'ofi-review',
        subSection1: 'transfers',
        subSection2: 'ofi-review',
        customPageName: 'wb_modal-transfers-ofi-review'
      },
      process: {
        processName: 'tdw:wbt:ofi:transfer',
        processType: 'tdw:wbt:non-recurring:transfer:start'
      }
    },
    modalTransfersOfi_Confirmation: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'ofi-confirmation',
        subSection1: 'transfers',
        subSection2: 'ofi-confirmation',
        customPageName: 'wb_modal-transfers-ofi-confirmation'
      },
      process: {
        processName: 'tdw:wbt:ofi:transfer',
        processType: 'tdw:wbt:non-recurring:transfer:complete'
      }
    },
    modalTransfersSecurities: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'securities',
        subSection1: 'transfers',
        subSection2: 'securities',
        customPageName: 'wb_modal-transfers-securities'
      }
    },
    modalTransfersAccountLinking: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'account-linking',
        subSection1: 'transfers',
        subSection2: 'account-linking',
        customPageName: 'wb_transfers-account-linking'
      }
    },
    modalTransfersAccountUnlink: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'unlink',
        subSection1: 'transfers',
        subSection2: 'unlink',
        customPageName: 'wb_transfers-overview-unlink'
      }
    }
  };

  static transfersPageTaggingEvents: DataAnalyticsTaggingEvents = {
    pageTransfersDereg: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'dereg',
        subSection1: 'transfers',
        subSection2: 'dereg',
        customPageName: 'wb_transfers-withdrawal-rsp-resp'
      }
    },
    pageTranfersWithdrawalResp: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'resp withdrawal',
        subSection1: 'transfers',
        subSection2: 'resp withdrawal',
        customPageName: 'wb_transfers-withdrawal-resp'
      },
      process: {
        processName: 'tdw:wbt:RESP',
        processType: 'tdw:wbt:resp:start'
      }
    },
    pageTranfersWithdrawalRsp: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'rrsp withdrawal',
        subSection1: 'transfers',
        subSection2: 'rrsp withdrawal',
        customPageName: 'wb_transfers-withdrawal-rrsp'
      },
      process: {
        processName: 'tdw:wbt:RRSP',
        processType: 'tdw:wbt:rrsp:start'
      }
    },
    pageTransfersTransfers_OverviewTransfers_Entry: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'overview',
        subSection1: 'transfers',
        subSection2: 'overview',
        customPageName: 'wb_transfers-overview'
      }
    },
    pageTransfersTransfers_OverviewTransfers_Status: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'status',
        subSection1: 'transfers',
        subSection2: 'status',
        customPageName: 'wb_transfers-status'
      }
    },
    pageTransfersOfi_Open_Banking: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'outside-td',
        subSection1: 'transfers',
        subSection2: 'outside-td',
        customPageName: 'wb_transfers-outside-td'
      }
    },
    pageTransfersTransfers_OverviewLinked_Accounts: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'overview-linked accounts',
        subSection1: 'transfers',
        subSection2: 'overview-linked accounts',
        customPageName: 'wb_transfers-overview-linked accounts'
      }
    },
    pageTransfersOutsideTdReviewConfirm: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'outside-td-review-confirm',
        subSection1: 'transfers',
        subSection2: 'outside-td-review-confirm',
        customPageName: 'wb_transfers-outside-td-review-confirm'
      }
    },
    pageTransfersOutsideTdSuccess: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'outside-td-success',
        subSection1: 'transfers',
        subSection2: 'outside-td-success',
        customPageName: 'wb_transfers-outside-td-success'
      }
    }
  };

  static readonly transfersLinkEventNames: Record<string, string> = {
    howMuchCanITransferLink: 'tdw:wbt:transfers outside td:how much can I transfer',
    continueButton: 'tdw:wbt:transfers outside td:continue',
    watchTheVideoLink: 'tdw:wbt:transfers outside td:watch the video',
    interacTransferLink:'tdw:wbt:transfers outside td:interac e-transfer',
    linkAnOutsideAccountLink: 'tdw:wbt:transfers outside td account linking:link an outside account',
    linkingAccountModalTooltipLink: 'tdw:wbt:transfers outside td account linking:what accounts can I transfer from',
    linkingAccountModalPrivacyLink: 'tdw:wbt:transfers outside td account linking:privacy terms',
    linkingAccountModalTermsConditionsLink: 'tdw:wbt:transfers outside td account linking:terms and conditions',
    linkingAccountModalPADLink: 'tdw:wbt:transfers outside td account linking:pad agreement',
    linkingAccountModalContinueButton: 'tdw:wbt:transfers outside td account linking:continue',
    linkNewAccountButton: 'tdw:wbt:transfers overview:get started',
    linkedAccountsUnlinkButton: 'tdw:wbt:transfers overview:unlink account',
    unlinkAccountModalUnlinkButton: 'tdw:wbt:transfers overview:unlink account:unlink',
    reviewAndConfirmEditButton: 'tdw:wbt:transfers outside td:review and confirm:edit',
    startAnotherTransferButton: 'tdw:wbt:transfers outside td success:start another transfer',
    viewAccountDetailsButton: 'tdw:wbt:transfers outside td interac success:view account details',
    startAnotherTransferButtonOpenBanking: 'tdw:wbt:transfers outside td success:start another transfer',
    viewAccountDetailsButtonOpenBanking: 'tdw:wbt:transfers outside td success:view account details',
    startAnotherTransferButtonInteract: 'tdw:wbt:transfers outside td interac success:start another transfer',
    viewAccountDetailsButtonInteract: 'tdw:wbt:transfers outside td interac success:view account details'
  }

  static getTransfersPageStepEvent(name: string,
                                   subSection1: string,
                                   subSection2: string,
                                   customPageName: string,
                                   processName: string): DataAnalyticsTaggingEvent {
    const eventData: DataAnalyticsTaggingEvent = {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name,
        subSection1,
        subSection2,
        customPageName
      },
      process: {
        processName
      }
    }
    if (name.includes('confirmation')){
      eventData.process.processType = `tdw:wbt:${name.split(' ')[0]}:complete`
    }
    return eventData;
  }

  static getTransfersPageStepEvents(pageName: string, customPageName: string, processName: string): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: pageName,
        subSection1: 'transfers',
        subSection2: pageName,
        customPageName: `wb_transfers-resp-${customPageName}`
      },
      process: {
        processName: `tdw:wbt:RESP:${processName} withdrawal`
      }
    }
  }

  static getTransferCardClickEventName(transferType: TransferType): string {
    let eventName = '';

    switch (transferType) {
      case 'cash':
        eventName = 'transfer cash';
        break;
      case 'ofi':
        eventName = 'transfer ofi';
        break;
      case 'deregisteredWithdraw':
        eventName = 'RRSP RESP withdrawals';
        break;
      case 'securities':
        eventName = 'transfer securities';
        break;
    }

    return eventName;
  }

  static getTransferDocumentLinkEventName(type: TransferDocumentType): string {
    let eventName = '';

    switch (type) {
      case 'privacy':
        eventName = TransfersAnalytics.transfersLinkEventNames.linkingAccountModalPrivacyLink;
        break;
      case 'terms_conditions':
        eventName = TransfersAnalytics.transfersLinkEventNames.linkingAccountModalTermsConditionsLink;
        break;
      case 'pad':
        eventName = TransfersAnalytics.transfersLinkEventNames.linkingAccountModalPADLink;
        break;
    }

    return eventName;
  }

  static taggingEvents: DataAnalyticsTaggingEvents = {
    ...this.transfersModalTaggingEvents,
    ...this.transfersPageTaggingEvents
  };
}
